define('app/views/lazy_single_view',['app/setup'], function(takhfifan) {

  takhfifan.LazySingleView = Backbone.View.extend({

    initialize: function(options) {
      this.lazyLoad();
      var _this = this;
      $(window).on('scroll', _.throttle(function(){
        _this.lazyLoad();
      },500));
      $(window).on('resize', function(){
        _this.lazyLoad();
      });
    },

    isOnScreen: function(el) {
      var win = $(window);
      var viewport = {
      	top: win.scrollTop()
      };
      viewport.bottom = viewport.top + win.height();
      var bounds = el.offset();
      bounds.bottom = bounds.top + el.outerHeight();
      return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    },

    lazyLoad: function() {
      if(!this.$el.hasClass('lazy-loaded') && this.isOnScreen(this.$el)){
        this.$el.prop('src', this.$el.data('src'));
        this.$el.addClass('lazy-loaded');
      }
    }

  });
});

